import {
    Component,
    ChangeDetectionStrategy,
    OnInit,
    ChangeDetectorRef,
    OnDestroy,
    ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { SellingTypeEnum } from '@classifieds-sell/datalayer';
import { FormHelperService } from '@classifieds-sell/shared';
import { MotorsDraftFacade } from '@classifieds-sell/state';
import { isEditOrRelistPage } from '@classifieds-sell/shared';
import { Subject } from 'rxjs';
import { MotorsSectionBase } from '../motors-section-base';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'motors-accepted-payments-section',
    templateUrl: './motors-accepted-payments-section.component.html',
    styleUrls: ['./motors-accepted-payments-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MotorsAcceptedPaymentsSectionComponent
    extends MotorsSectionBase
    implements OnInit, OnDestroy {
    private _destroyed$: Subject<void> = new Subject<void>();

    @ViewChild('motorsAcceptedPaymentsSectionForm')
    motorsAcceptedPaymentsSectionForm: NgForm;
    checkgroup: any;
    acceptedPaymentsGroup: any;
    displayError: boolean;
    inputDisabled: boolean;

    constructor(
        public draftFacade: MotorsDraftFacade,
        private _changeDetectorRef: ChangeDetectorRef,
        private _formHelperService: FormHelperService,
        private route: ActivatedRoute
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.setInputDisable();
            this._changeDetectorRef.markForCheck();
        });
    }

    setInputDisable(){
        this.inputDisabled = this.metadata.bidCount > 0;
    }

    isValid(): boolean {
        if (this.draftData.listingDetails.sellingType === SellingTypeEnum.classified) {
            return true; // don't validate on classified
        }

        if (
            !this.draftData.listingDetails.acceptedPayments_Cash &&
            !this.draftData.listingDetails.acceptedPayments_NZBank &&
            !this.draftData.listingDetails.acceptedPayments_Other
        ) {
            this.displayError = true;
            this._changeDetectorRef.markForCheck();
            return false;
        }
        this._formHelperService.validate(
            this.motorsAcceptedPaymentsSectionForm
        );
        return this.formValidationWhenDisabled(this.motorsAcceptedPaymentsSectionForm);
    }

    protected formValidationWhenDisabled(ngForm: NgForm): boolean {
        // When there is a bid, this becomes greyed out and read-only then all inputs are disabled => form should be valid
        const isFormDisabled = ngForm.form.disabled;
        return (((isEditOrRelistPage(this.route) && isFormDisabled)
            || ngForm.form.valid));
    }

    dirty(): boolean {
        return this.motorsAcceptedPaymentsSectionForm.form.dirty;
    }

    onSelectionChange() {
        this.displayError = false;
        this.publish();
    }
}
